import type { ICompanyApplicationTenant, ICompanyUserTenant } from "@models";

/** App map id used for hub sub-applications API
 * (`/api/company/{companyUuid}/app-map/{appMapId}/sub-applications`).
 */
export function getSolutionsAppMapId(
  appTenant: ICompanyApplicationTenant,
): string {
  if (appTenant.isLite) {
    return (
      appTenant.liteCompanyAppMapId?.trim() ||
      appTenant.tenantInfo?.[0]?.compAppMapId?.trim() ||
      ""
    );
  }

  return (
    appTenant.appMapId?.trim() ||
    appTenant.tenantInfo?.[0]?.compAppMapId?.trim() ||
    ""
  );
}

export function mapUserTenantsToApplicationTenants(
  rows: ICompanyUserTenant[] | undefined,
): ICompanyApplicationTenant[] {
  if (!rows?.length) return [];
  const byApp = new Map<string, ICompanyApplicationTenant>();

  for (const ut of rows) {
    const isLite = ut.isLite === true;
    const solutionsAppMapId = isLite
      ? (ut.liteCompanyAppMapId?.trim() ?? "")
      : (ut.appMapId?.trim() ?? "");
    const key = solutionsAppMapId || ut.applicationId;

    let entry = byApp.get(key);
    if (!entry) {
      entry = {
        applicationId: ut.applicationId,
        applicationVersionId: "",
        applicationName: ut.applicationName,
        applicationLabel: ut.label || ut.applicationName,
        applicationDescription: ut.applicationDescription,
        applicationVersion: ut.applicationVersion ?? "",
        tenantInfo: [],
        appMapId: isLite ? solutionsAppMapId : (ut.appMapId ?? ""),
        isLite,
        liteCompanyAppMapId: ut.liteCompanyAppMapId,
        termsAccepted: ut.termsAccepted ?? false,
        termsId: ut.termsId ?? "",
        dxpTermsRequired: ut.dxpTermsRequired ?? false,
      };
      byApp.set(key, entry);
    }

    const tenantLabel = isLite
      ? ut.label?.trim() || ut.tenantName?.trim() || ut.applicationName
      : ut.tenantName?.trim() || ut.label?.trim() || ut.applicationName;
    const tenantInstanceId = isLite
      ? `${solutionsAppMapId || ut.applicationId}-lite`
      : solutionsAppMapId
        ? `${solutionsAppMapId}-${tenantLabel}`
        : `${ut.applicationId}-${tenantLabel}`;

    entry.tenantInfo.push({
      compAppMapId: solutionsAppMapId,
      tenantInstanceId,
      tenantInstanceName: tenantLabel,
      connEndpoint: ut.connEndpoint,
    });
  }

  return [...byApp.values()].filter((e) => e.tenantInfo.length > 0);
}
